// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"585":"MainLayout","756":"AuthLayout"}[chunkId] || chunkId) + "." + {"33":"9c99b8b1","156":"65f0830e","349":"3ceac000","585":"1f04ec2f","756":"1cc9ec86"}[chunkId] + ".css";
};